




























import Vue from "vue";
import ZenyaDialog from "../../dialogs/ZenyaDialog.vue";

export default Vue.extend({
    name: "AiFeedbackDialog",
    components: { ZenyaDialog },
    props: {
        value: {
            type: Boolean,
            default: () => false
        },
        title: {
            type: String,
            default: () => ""
        }
    },
    data: () => ({
        feedbackReason: "",
        isFeedbackDialogOpen: false
    }),
    watch: {
        value(newval: boolean) {
            this.isFeedbackDialogOpen = newval;
        }
    },
    methods: {
        handleFeedbackDialogInput() {
            if (!(this.$refs.form as HTMLFormElement).validate()) {
                (this.$refs.feedbackArea as HTMLElement).focus();
                return;
            }

            this.isFeedbackDialogOpen = false;
            this.$emit("input", false);
        },
        cancelFeedback() {
            this.isFeedbackDialogOpen = false;
            this.$emit("input", false);
            this.feedbackReason = "";
        },
        handleSubmit() {
            if (!(this.$refs.form as HTMLFormElement).validate()) return;
            this.$emit("submit", this.feedbackReason);
            this.feedbackReason = "";
        }
    }
});
